// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_UpdateStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for update_status endpoint
 *
 * Returns the updated plano record with a message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planoscontas_UpdateStatusResponseDados {
id: number
franquia_id: number
status: string
nome: string
created_at: string
updated_at: string
message: string
}

export type Planoscontas_UpdateStatusResponse = ApiResponse<Planoscontas_UpdateStatusResponseDados>;

registerResponseContract('Planoscontas_UpdateStatusResponse', {
  id:          { type: 'number',  required: true },
  franquia_id: { type: 'number',  required: true },
  status:      { type: 'string',  required: true },
  nome:        { type: 'string',  required: false },
  created_at:  { type: 'string',  required: true },
  updated_at:  { type: 'string',  required: true },
  message:     { type: 'string',  required: true },
})
